<template>
  <div class="basic-information">
    <fieldset class="info-group">
      <legend>{{ $t("kyc.section.basicInformation") }}</legend>
    </fieldset>
    <fieldset :disabled="kycStatus=== 'submitted'?true:false">
      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('companyName'), 'valid': isFormFieldValid('companyName')}">
          <div class="input-group">
            <input id="companyNameInput"
                   name="companyName"
                   data-vv-as="Company Name"
                   v-model="basicInformation.companyName"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="companyName">Company Name：</label>
            <i class="bar"></i>
            <small v-show="errors.has('companyName')"
                   class="help text-danger">{{ errors.first('companyName') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('registrationNumber'), 'valid': isFormFieldValid('registrationNumber')}">
          <div class="input-group">
            <input id="registrationNumberInput"
                   name="registrationNumber"
                   data-vv-as="Registration Number"
                   v-model="basicInformation.registrationNumber"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="registrationNumber">Registration Number：</label>
            <i class="bar"></i>
            <small v-show="errors.has('registrationNumber')"
                   class="help text-danger">{{ errors.first('registrationNumber') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('incorporationDate'), 'valid': isFormFieldValid('incorporationDate')}">
          <div class="input-group">
            <vuestic-date-picker id="incorporationDateInput"
                                 name="incorporationDate"
                                 data-vv-as="Incorporation Date"
                                 v-validate="'required'"
                                 required
                                 v-model="basicInformation.incorporationDate" />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="incorporationDate">Incorporation Date：</label>
            <i class="bar"></i>
            <small v-show="errors.has('incorporationDate')"
                   class="help text-danger">{{ errors.first('incorporationDate') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': countryStatus, 'valid': countryStatus}">
          <div class="input-group">
            <vuestic-kyc-select id="registeredCountryorRegionInput"
                                name="registeredCountryOrRegion"
                                data-vv-as="Registered Country or Region"
                                v-validate="'required'"
                                required
                                :label="$t('kyc.registeredCountryOrRegion') + '：'"
                                v-model="basicInformation.registeredCountryOrRegion"
                                option-key="value"
                                :options="CountriesList"
                                ref="regionInput"
                                @input="regionForbiddenInput"
                                :disabled="kycStatus=== 'submitted'?true:false"
                                clearable/>
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <!-- <i class="fa fa-check valid-icon icon-right input-icon"></i> -->
            <i class="fa icon-right input-icon"></i>
            <!-- <i class="bar"></i> -->
            <small v-show="countryStatus"
                   class="help text-danger">{{ errors.first('registeredCountryOrRegion') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('registeredAddress'), 'valid': isFormFieldValid('registeredAddress')}">
          <div class="input-group">
            <input id="registeredAddressInput"
                   name="registeredAddress"
                   data-vv-as="Registered Address"
                   v-model="basicInformation.registeredAddress"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="registeredAddress">Registered Address：</label>
            <i class="bar"></i>
            <small v-show="errors.has('registeredAddress')"
                   class="help text-danger">{{ errors.first('registeredAddress') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('correspondenceAddress'), 'valid': isFormFieldValid('correspondenceAddress')}">
          <div class="input-group">
            <input id="correspondenceAddressInput"
                   name="correspondenceAddress"
                   data-vv-as="Correspondence Address"
                   v-model="basicInformation.correspondenceAddress"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="correspondenceAddress">Correspondence Address：</label>
            <i class="bar"></i>
            <small v-show="errors.has('correspondenceAddress')"
                   class="help text-danger">{{ errors.first('correspondenceAddress') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="form-group with-icon-right"
             :class="{'has-error': typeStatus, 'valid': typeStatus}">
          <div class="input-group">
            <vuestic-kyc-select name="companyType"
                                data-vv-as="Company Type"
                                v-validate="'required'"
                                required
                                :label="$t('kyc.companyType') + '：'"
                                v-model="basicInformation.companyType"
                                option-key="value"
                                :options="CompanyTypes"
                                ref="companyTypeInput"
                                @input="companyTypeForbiddenInput"
                                :disabled="kycStatus=== 'submitted'?true:false" />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa icon-right input-icon"></i>
            <small v-show="typeStatus"
                   class="help text-danger">{{ errors.first('companyType') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('contactPhone'), 'valid': isFormFieldValid('contactPhone')}">
          <div class="input-group">
            <input id="contactPhoneInput"
                   name="contactPhone"
                   data-vv-as="Contact Phone"
                   v-model="basicInformation.contactPhone"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="contactPhone">Contact Phone：</label>
            <i class="bar"></i>
            <small v-show="errors.has('contactPhone')"
                   class="help text-danger">{{ errors.first('contactPhone') }}</small>
          </div>
        </div>
      </div>

      <div class="info-group"
           v-if="kycStatus=== 'firstEdit'">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('contactEmail'), 'valid': isFormFieldValid('contactEmail')}">
          <div class="input-group">
            <input id="contactEmailInput"
                   name="contactEmail"
                   data-vv-as="Contact Email"
                   v-model="basicInformation.contactEmail"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required|email'"
                   required/>
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="contactEmail">Contact Email：</label>
            <i class="bar"></i>
            <small v-show="errors.has('contactEmail')"
                   class="help text-danger">{{ errors.first('contactEmail') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('emailVerifyCode'), 'valid': isFormFieldValid('emailVerifyCode')}">
          <div class="input-group">
            <input id="verficationCodeInput"
                   name="emailVerifyCode"
                   data-vv-as="E-mail Verfication Code"
                   v-model="basicInformation.emailVerifyCode"
                   maxlength="6"
                   autocomplete="off"
                   v-validate="'required|verifyCode'"
                   required />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="emailVerifyCode">E-mail Verfication Code：</label>
            <i class="bar"></i>
            <small v-show="errors.has('emailVerifyCode')"
                   class="help text-danger">{{ errors.first('emailVerifyCode') }}</small>
          </div>
          <button class="btn btn-primary btn-micro btn-send send-email" @click="sendEmail" :disabled="sendEmailDisabled">{{sendEmailText}}</button>
        </div>
      </div>
      <div class="info-group"
           v-if="kycStatus=== 'saved' || kycStatus=== 'submitted'">
        <div class="form-group with-icon-right"
             :class="{'has-error': errors.has('contactEmail'), 'valid': isFormFieldValid('contactEmail')}">
          <div class="input-group">
            <input id="contactEmailInput"
                   name="contactEmail"
                   data-vv-as="Contact Email"
                   v-model="basicInformation.contactEmail"
                   maxlength="128"
                   autocomplete="off"
                   v-validate="'required|email'"
                   required
                   disabled />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"
                   for="contactEmail">Contact Email：</label>
            <i class="bar"></i>
            <small v-show="errors.has('contactEmail')"
                   class="help text-danger">{{ errors.first('contactEmail') }}</small>
          </div>
          <button class="btn btn-primary btn-micro btn-send"
                  @click="changeEmail" :disabled="kycStatus=== 'submitted'">{{ $t("kyc.change") }}</button>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"></div>
      </div>
    </fieldset>

    <vuestic-modal :show.sync="changeEmailShow"
                   ref="changeEmail"
                   :okText="'modal.confirm2' | translate"
                   style="height: 100%;width:60vw;"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   alignModal=""
                   class="change-email-show">
      <div slot="title">{{ $t("kyc.changeEmail") }}</div>
      <!-- <div slot="title">{{'modal.refundReason' | translate}}</div> -->
      <div>
        <form>
          <div class="va-row">
            <div class="flex xs12 md12">
              <fieldset>
                <div class="form-group with-icon-right"
                     :class="{'has-error': errors.has('changeContactEmail'), 'valid': isFormFieldValid('changeContactEmail')}">
                  <div class="input-group">
                    <input name="changeContactEmail"
                           data-vv-as="Contact Email"
                           v-model="changeEmailBean.changeContactEmail"
                           autocomplete="off"
                           v-validate="'required|email'"
                           required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label"
                           for="changeContactEmail">Contact Email：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('changeContactEmail')"
                           class="help text-danger">{{ errors.first('changeContactEmail') }}</small>
                  </div>
                </div>
                <div class="form-group with-icon-right"
                     :class="{'has-error': errors.has('changeVerficationCode'), 'valid': isFormFieldValid('changeVerficationCode')}">
                  <div class="input-group">
                    <input name="changeVerficationCode"
                           data-vv-as="E-mail Verfication Code"
                           v-model="changeEmailBean.changeVerficationCode"
                           maxlength="6"
                           autocomplete="off"
                           v-validate="'required|verifyCode2'"
                           required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label"
                           for="changeVerficationCode">E-mail Verfication Code：</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('changeVerficationCode')"
                           class="help text-danger">{{ errors.first('changeVerficationCode') }}</small>
                  </div>
                  <button class="btn btn-primary btn-micro btn-send send-email" :disabled="sendChangeEmailDisabled"
                          @click="changeSend">{{sendChangeEmailText}}</button>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>

  </div>
</template>
<script>
import { request } from '@/utils/utils.js'
import mixin from '../mixins/mixin'

export default {
  mixins: [mixin],
  inject: ['merchantNo'],
  props: {
    kycStatus: {
      type: String,
      default: '',
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    let token = localStorage.getItem('Authorization')
    let that = this
    this.$validator.extend('verifyCode', {
      validate: async (value, ref) => {
        if (that.kycStatus === 'saved') {
          return true
        }
        // if (that.formFields['contactEmail'] && !that.formFields['contactEmail'].validated && !that.formFields['contactEmail'].valid) {
        //   that.$message({
        //     type: 'error',
        //     message: 'The Contact Email field is required.'
        //   })
        //   return false
        // }
        if (value.length !== 6) {
          return false
        }
        let result = false
        await request({
          url: `api/dashboard/merchant/kyc/verifyCode?access_token=${token}&email=${this.basicInformation.contactEmail}&code=${this.basicInformation.emailVerifyCode}`,
          method: 'POST',
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        }).then((res) => {
          if (res && res.data.code === '10000') {
            result = true
          } else {
            result = false
          }
        })
        return result
        // return /^(\d3|^\d{3}[.-]?)?\d{3}[.-]?\d{4}$/.test(value)
      },
      // 提示信息，不符合规则提示语
      // <span v-show="errors.has('phone')" class="error-message"> {{ errors.first('phone') }} </span>
      getMessage: (field) => 'The ' + field + ' is invalid.'
    })

    this.$validator.extend('verifyCode2', {
      validate: async (value, ref) => {
        if (that.formFields['changeContactEmail'] && !that.formFields['changeContactEmail'].validated && !that.formFields['changeContactEmail'].valid) {
          that.$message({
            type: 'error',
            message: 'The Contact Email field is required.'
          })
          return false
        }
        if (value.length !== 6) {
          return false
        }
        let result = false
        await request({
          url: `api/dashboard/merchant/kyc/verifyCode?access_token=${token}&email=${this.changeEmailBean.changeContactEmail}&code=${this.changeEmailBean.changeVerficationCode}`,
          method: 'POST',
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        }).then((res) => {
          if (res && res.data.code === '10000') {
            result = true
          } else {
            result = false
          }
        })
        return result
        // return /^(\d3|^\d{3}[.-]?)?\d{3}[.-]?\d{4}$/.test(value)
      },
      // 提示信息，不符合规则提示语
      // <span v-show="errors.has('phone')" class="error-message"> {{ errors.first('phone') }} </span>
      getMessage: (field) => 'The ' + field + ' is invalid.'
    })

    return {
      CompanyTypes: [
        { id: 1, value: 'Corporation' },
        { id: 2, value: 'SoleProprietorship' },
        { id: 3, value: 'Limited' },
      ],
      basicInformation: {
        companyName: '',
        registrationNumber: '', // Registration Number
        incorporationDate: '', // Incorporation Date
        registeredCountryOrRegion: {}, // Registered Country or Region
        registeredAddress: '', // Registered Address
        correspondenceAddress: '', // Correspondence Address
        companyType: '', // Company Type
        contactPhone: '', // Contact Phone
        contactEmail: '', // Contact Email
        emailVerifyCode: '', // E-mail Verfication Code
      },
      countryStatus: false,
      typeStatus: false,
      // saved时
      changeEmailShow: true,
      changeEmailBean: {
        changeContactEmail: '',
        changeVerficationCode: '',
      },
      sendEmailText: 'Send',
      timer: null,
      sendEmailDisabled: false,
      CountriesList: [],

      sendChangeEmailText: 'Send',
      changeTimer: null,
      sendChangeEmailDisabled: false,
    }
  },
  async mounted () {
    if (this.CountriesList.length === 0) {
      await this.getCountryAndRegions()
    }
    if (this.$refs.regionInput) {
      // this.$refs.regionInput.$el.getElementsByTagName('input')[0].readOnly = true
      this.$refs.regionInput.$el.getElementsByTagName('input')[0].autocomplete = 'off'
    }
    if (this.$refs.companyTypeInput) {
      this.$refs.companyTypeInput.$el.getElementsByTagName('input')[0].readOnly = true
      this.$refs.companyTypeInput.$el.getElementsByTagName('input')[0].autocomplete = 'off'
    }
    // 获取保存的数据
    let that = this
    if (this.kycStatus === 'firstEdit') {
      this.getMerchantKYCInfo(1, res => {
        that.setBasicInfo(res.base_info)
      })
    } else if (this.merchantData.base_info) {
      that.setBasicInfo(this.merchantData.base_info)
    } else {}
  },
  computed: {
    // initSelectedVaild () {
    //   return this.countryStatus
    // },
    // initSelectedVaildTypeStatus () {
    //   return this.typeStatus
    // },
  },
  methods: {
    setBasicInfo (info) {
      if (!info) return
      let currentCountry = this.CountriesList.filter(country => info.registered_country_or_region === Number(country.id))[0]
      let currentCompanyType = this.CompanyTypes.filter(companyType => info.company_type === companyType.id)[0]
      this.basicInformation = {
        companyName: info.company_name,
        registrationNumber: info.registration_number,
        incorporationDate: info.incorporation_date,
        registeredAddress: info.registered_address,
        correspondenceAddress: info.correspondence_address,
        contactPhone: info.contact_phone,
        contactEmail: info.contact_email,
        emailVerifyCode: info.email_verify_code,
        registeredCountryOrRegion: currentCountry,
        companyType: currentCompanyType,
      }
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    saveBasicInfo (cb) {
      if (!this.basicInformation.registeredCountryOrRegion || !this.basicInformation.registeredCountryOrRegion.id) {
        this.countryStatus = true
      } else {
        this.countryStatus = false
      }
      if (!this.basicInformation.companyType) {
        this.typeStatus = true
      } else {
        this.typeStatus = false
      }
      // console.log(this.basicInformation, 'this.basicInformation')
      let that = this
      this.$validator.validateAll(this.basicInformation).then((result) => {
        if (result) {
          let params = {
            page: 1,
            base_info: {
              company_name: that.basicInformation.companyName,
              company_type: that.basicInformation.companyType.id,
              contact_email: that.basicInformation.contactEmail,
              contact_phone: that.basicInformation.contactPhone,
              correspondence_address: that.basicInformation.correspondenceAddress,
              email_verify_code: that.basicInformation.emailVerifyCode,
              incorporation_date: that.basicInformation.incorporationDate,
              registered_address: that.basicInformation.registeredAddress,
              registered_country_or_region: that.basicInformation.registeredCountryOrRegion.id,
              registration_number: that.basicInformation.registrationNumber,
            }
          }
          this.$emit('updateKycInformation', params, function () {
            let flag = true
            cb(flag)
          })
        } else {
          let flag = false
          cb(flag)
        }
      })
    },
    getBasicInfo () {
      let baseInfo = new Promise((resolve, reject) => {
        if (!this.basicInformation.registeredCountryOrRegion || !this.basicInformation.registeredCountryOrRegion.id) {
          this.countryStatus = true
        } else {
          this.countryStatus = false
        }
        if (!this.basicInformation.companyType) {
          this.typeStatus = true
        } else {
          this.typeStatus = false
        }
        // console.log(this.basicInformation, 'this.basicInformation')
        let that = this
        this.$validator.validateAll(this.basicInformation).then((result) => {
          if (result) {
            let params = {
              base_info: {
                company_name: that.basicInformation.companyName,
                company_type: that.basicInformation.companyType.id,
                contact_email: that.basicInformation.contactEmail,
                contact_phone: that.basicInformation.contactPhone,
                correspondence_address: that.basicInformation.correspondenceAddress,
                email_verify_code: that.basicInformation.emailVerifyCode,
                incorporation_date: that.basicInformation.incorporationDate,
                registered_address: that.basicInformation.registeredAddress,
                registered_country_or_region: that.basicInformation.registeredCountryOrRegion.id,
                registration_number: that.basicInformation.registrationNumber,
              }
            }
            resolve(params)
          } else {
            this.$message({
              type: 'warn',
              message: 'Please fill in Basic Information'
            })
          }
        })
      })
      return baseInfo
    },
    isValidateBasicInfo () {
      return Object.keys(this.formFields).reduce((result, item) => {
        return result && this.isFormFieldValid(item)
      }, true)
    },
    regionForbiddenInput (val) {
      if (!val) {
        this.$refs.regionInput.$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this.countryStatus = true
      } else {
        this.countryStatus = false
      }
      if (this.kycStatus === 'saved' && val.id === 344) {
        this.$emit('changeRegionHK', true)
      } else {
        this.$emit('changeRegionHK', false)
      }
    },
    companyTypeForbiddenInput (val) {
      if (!val) {
        this.$refs.companyTypeInput.$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this.typeStatus = true
      } else {
        this.typeStatus = false
      }
    },
    // 发送验证码
    sendEmail () {
      let that = this
      if (that.formFields['contactEmail'] && !that.formFields['contactEmail'].validated && !that.formFields['contactEmail'].valid) {
        that.$message({
          type: 'error',
          message: 'The Contact Email field is required.'
        })
        return
      }
      let time = 60
      that.timer = null
      that.$validator.validateAll({ 'contactEmail': this.basicInformation.contactEmail }).then((result) => {
        if (result) {
          that.sendEmailDisabled = true
          that.sendEmailText = time + 's'
          that.timer = setInterval(() => {
            time--
            that.sendEmailText = time + 's'
            if (time === 0) {
              clearInterval(that.timer)
              that.timer = null
              that.sendEmailText = 'Send'
              this.sendEmailDisabled = false
            }
          }, 1000)
          let token = localStorage.getItem('Authorization')
          request({
            method: 'POST',
            url: `api/dashboard/merchant/kyc/sendVerifyCode?access_token=${token}&email=${this.basicInformation.contactEmail}`,
            // data: '',
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          }).then((res) => {
            let data = res.data
            if (data.code === '10000') {
              that.$message({
                type: 'success',
                message: data.data
              })
            } else {
              that.$message({
                type: 'warn',
                message: data.msg
              })
            }
          })
        }
      })
    },
    // saved
    changeEmail () {
      let that = this
      this.$refs.changeEmail.open()
      this.$validator.reset()
      // 关闭定时器
      if (that.changeTimer) {
        clearInterval(that.changeTimer)
        that.changeTimer = null
        that.sendChangeEmailText = 'Send'
        that.sendChangeEmailDisabled = false
      }

      this.changeEmailBean.changeContactEmail = ''
      this.changeEmailBean.changeVerficationCode = ''
      this.$refs.changeEmail.ok = () => {
        that.$validator.validateAll(this.changeEmailBean).then((result) => {
          if (result) {
            let token = localStorage.getItem('Authorization')
            request({
              method: 'POST',
              url: `api/dashboard/merchant/kyc/changemail?access_token=${token}&email=${this.changeEmailBean.changeContactEmail}`,
              headers: {
                'Content-type': 'application/x-www-form-urlencoded'
              }
            }).then((res) => {
              let data = res.data
              if (data.code === '10000') {
                that.$refs.changeEmail.close()
                that.basicInformation.contactEmail = that.changeEmailBean.changeContactEmail
                that.$message({
                  type: 'success',
                  message: 'Change Success'
                })
              } else {
                that.$message({
                  type: 'success',
                  message: data.msg
                })
              }
            })
          }
        })
        // this.$refs.changeEmail.close();
      }
    },
    changeSend (event) {
      event.stopPropagation()
      event.preventDefault()
      let that = this
      let time = 60
      that.changeTimer = null
      this.$validator.validateAll({ 'changeContactEmail': this.changeEmailBean.changeContactEmail }).then(result => {
        if (result) {
          that.sendChangeEmailDisabled = true
          that.sendChangeEmailText = time + 's'
          that.changeTimer = setInterval(() => {
            time--
            that.sendChangeEmailText = time + 's'
            if (time === 0) {
              clearInterval(that.changeTimer)
              that.changeTimer = null
              that.sendChangeEmailText = 'Send'
              that.sendChangeEmailDisabled = false
            }
          }, 1000)
          let token = localStorage.getItem('Authorization')
          request({
            method: 'POST',
            url: `api/dashboard/merchant/kyc/sendVerifyCode?access_token=${token}&email=${this.changeEmailBean.changeContactEmail}`,
            // data: '',
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          }).then((res) => {
            let data = res.data
            if (data.code === '10000') {
              that.$message({
                type: 'success',
                message: data.data
              })
            } else {
              that.$message({
                type: 'warn',
                message: data.msg
              })
            }
          })
        }
      })
    },
    async getCountryAndRegions () {
      let that = this
      let token = localStorage.getItem('Authorization')
      await request({
        method: 'post',
        url: `api/dashboard/merchant/kyc/getCountryAndRegions?access_token=${token}`,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => {
          if (res.data.code === '10000') {
            that.CountriesList = that.updateCountryAndRegions(res.data.data)
          }
        }).catch(() => {})
    },
    updateCountryAndRegions (data) {
      let countryList = []
      for (let item in data) {
        countryList.push({
          id: data[item],
          value: item,
        })
      }
      return countryList
    },
  },
}
</script>
<style lang="scss" scoped>
.basic-information {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .btn-send {
    height: 38px;
  }
  /deep/ .change-email-show {
    .modal-dialog {
      max-width: 400px;
    }
    .modal-body {
      padding-bottom: 0;
    }
  }

  /deep/ #registeredCountryorRegionInput .scrollbar-wrapper {
    max-height: 200px !important;
    // overflow-y: scroll;
  }

  /deep/ button.send-email[disabled='disabled'] {
    color: #ffffff;
  }
}
</style>
